module.exports = __webpack_public_path__ + "images/application/i-add-circle-6149a899.svg";